import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {RoutesEnum} from '../../core/services/navigation/routes.enum';
import {AuthGuardService} from '../../core/services/security/auth-guard.service';
import {CreateUserComponent} from './create-user/create-user.component';
import {UserComponent} from './user.component';
import {UsersListComponent} from './users-list/users-list.component';
import {UsersRoutesEnum} from './services/navigation/users-routes.enum';
import {EditUserComponent} from './edit-user/edit-user.component';

const routes: Routes = [
  {
    path: RoutesEnum.USERS,
    component: UserComponent,
    canActivate: [AuthGuardService],
    children: [
      {
        path: UsersRoutesEnum.LIST,
        component: UsersListComponent,
      },
      {
        path: UsersRoutesEnum.CREATE,
        component: CreateUserComponent,
      },
      {
        path: UsersRoutesEnum.EDIT,
        component: EditUserComponent,
      },
    ],
  },
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
  ],
  exports: [RouterModule],
})
export class UserRoutingModule {
}
